export const isLoading = (state) => state.accidents.isLoading
export const isSuccess = (state) => state.accidents.isSuccess
export const isLoadingSend = (state) => state.accidents.isLoadingSend
export const isSuccessSend = (state) => state.accidents.isSuccessSend
export const error = (state) => state.accidents?.error
export const accidents = (state) => state.accidents.accidents
export const accident = (state) => state.accidents.accident
export const actRepresentative = (state) => state.accidents.getActRepresentative
